import { Box, Chip } from '@mui/material';
import { ReactElement } from 'react';

export interface HeapMaskChipProps {
  label: string;
  color: string;
  enabled: boolean;
  onClick?: () => void;
}

export function HeapMaskChip({ label, color, enabled, onClick }: HeapMaskChipProps): ReactElement {
  return (
    <Chip
      size='small'
      variant={enabled ? 'filled' : 'outlined'}
      clickable
      onClick={onClick}
      aria-pressed={enabled}
      label={label}
      icon={
        <Box
          component='span'
          sx={{
            width: 10,
            height: 10,
            borderRadius: '2px',
            flexShrink: 0,
            backgroundColor: color,
            opacity: enabled ? 1 : 0.5,
          }}
        />
      }
      sx={{
        flexShrink: 0,
        '& .MuiChip-icon': { marginLeft: 1, marginRight: -0.5 },
      }}
    />
  );
}
